module.exports = __webpack_public_path__ + "static/media/einvoice-irbm-logo.01fc2d26.svg";